// history.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
    private history: string[] = [];

    constructor(private router: Router) {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.history.push(event.url);
            }
        });
    }

    hasHistory(): boolean {
        return this.history.length > 1;
    }
}
